import { Component, signal, ViewChild } from '@angular/core';
import { TitleComponent } from '../../../shared/components/title-component/title-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSort } from '@angular/material/sort';
import { MatRippleModule } from '@angular/material/core';
import { Site } from '../../../shared/model';
import { SuiviService } from '../../service/suivi-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-validation-suivi-component',
  imports: [
    TitleComponent,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatProgressSpinner,
    SearchBarComponent,
    MatRippleModule,
    MatButtonModule,
    MatCheckboxModule,
    DatePipe,
    MatIcon
  ],
  templateUrl: './validation-suivi-component.html',
  styleUrl: './validation-suivi-component.css',
})
export class ValidationSuiviComponent {
  displayedColumns: string[] = ['assure', 'categorie', 'puissance_en', 'dta', 'attestation', 'effet', 'fin', 'compagnie', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  loading = signal(false)

  data = signal<any[]>([])
  dataOrigin : any[] = []
  state = signal('')
  groupe = ''
  groupe_name = ""
  routeSub !: Subscription

  constructor(
    private suiviService : SuiviService,
    private sweetService : SweetAlertService,
    private toastr : ToastrService,
    private router : Router,
    private activatedRoute : ActivatedRoute
  ){}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.routeSub = combineLatest([this.activatedRoute.paramMap, this.activatedRoute.queryParamMap])
    .subscribe(([params, queryParams]) => {
      this.state.update(val => params.get('slug')??'');
      this.groupe = queryParams.get('groupe')??''
      this.groupe_name = queryParams.get('groupe_name')??''

      if(this.groupe){
        this.loadSitesGroupe(this.groupe)
        return;
      }
      switch (this.state()) {
        case 'reception':
          this.loadGroupe()
          break;
        case 'validation':
          this.loadSites()
          break;

        default:
          break;
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event : string){
    if(event != ""){
      this.searchValue.update(val => event)
      const search = event.toLowerCase().trim()
      this.data.update(val => this.dataOrigin.filter((site : Site) => site.name.toLowerCase().includes(search)))
    }else{
      this.data.update(val => this.dataOrigin.slice())
    }
  }

  loadSitesGroupe(groupe : string){
    this.loading.update(val => true)
    this.data.update(val => [])
    this.suiviService.bureauxGroupe(groupe).subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        console.log(res);
        this.data.update(val => res.slice())
        this.dataOrigin  = res.slice()
      },
      error : (err) =>{
        this.loading.update(val => false)
      }
    })
  }

  loadSites(){
    this.loading.update(val => true)
    this.data.update(val => [])
    this.suiviService.bureaux().subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        this.data.update(val => res.slice())
        this.dataOrigin  = res.slice()
      },
      error : (err) =>{
        this.loading.update(val => false)
      }
    })
  }

  loadGroupe(){
    this.loading.update(val => true)
    this.data.update(val => [])
    this.suiviService.groupes().subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        console.log(res);
        this.data.update(val => res.slice())
        this.dataOrigin  = res.slice()
      },
      error : (err) =>{
        this.loading.update(val => false)
      }
    })
  }

  goToBureau(id : string){
    this.router.navigateByUrl('/suivi/validation/'+id)
  }

  goToBureauGroupe(id : string, name : string){
    this.router.navigateByUrl('/suivi/reception?groupe='+id+'&groupe_name='+name)
  }

  goToBureauGroupeDetails(bureau : string, groupe : string){
    this.router.navigateByUrl('/suivi/reception/'+bureau)
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.routeSub.unsubscribe()
  }
}
